module.exports = "/components/components/comment-edit-6e6da1.html";